import { render } from "./AlertCircle.vue?vue&type=template&id=23dbcc80"
import script from "./AlertCircle.vue?vue&type=script&lang=js"
export * from "./AlertCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/AlertCircle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23dbcc80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23dbcc80', __exports__)) {
    api.reload('23dbcc80', __exports__)
  }
  
  module.hot.accept("./AlertCircle.vue?vue&type=template&id=23dbcc80", () => {
    api.rerender('23dbcc80', render)
  })

}


export default __exports__